import React from 'react';
import {
  Card,
  CardContent,

} from '@mui/material/';
import Menu from './Menu';
import { styled } from "@mui/material/styles";


const StyledCard = styled(Card)(({ theme, open }) => ({
  position: 'sticky',
  top: theme.spacing(0),
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary.contrastText,
  justifyContent: 'space-between',
  padding: theme.spacing(0.5),
}));


const SubMenuCard = (props) => {
  // const classes = useStyles();
  return (

    <StyledCard elevation={3}>
      <CardContent>
        <Menu data={props.data} rootURL={props.rootURL} />
      </CardContent>
    </StyledCard>
  )
};

export default SubMenuCard;
